<template>
  <div v-if="pageComponent" :id="pageComponent.uuid" :ref="pageComponent.uuid" :data-type="pageComponent.properties.element_type" class="survey" :style="mapCssProperties">
    <!-- Survey Intro (Role Selection)-->
    <div :ref="`role-selection-${pageComponent.uuid}`" class="role-selection-container" :style="setupSurveyVariables">
      <div class="header" :style="setupSurveyVariables">
        <p :style="setupSurveyVariables">{{ pageComponent.properties.welcome_title | stripHtml }}</p>
      </div>
      <div v-if="!survey.role" class="role-section-selection" :style="setupSurveyVariables">
        <p>{{ pageComponent.properties.welcome_intro_blurb | stripHtml }}</p>
        <ul class="roles-list" :style="setupSurveyVariables">
          <li v-for="(role, index) in roles" :key="index" class="role-button">
            <button @click="determineRoleContent(index)">{{ role }}</button>
          </li>
        </ul>

        <button @click="skipSurvey" class="skip-btn" :style="setupSurveyVariables">{{ pageComponent.properties.skip_survey_text | stripHtml  }}</button>
      </div>
    </div>

    <!-- Survey Portion -->
    <div :ref="`survey-${pageComponent.uuid}`" class="survey-container" :style="setupSurveyVariables">
      <div class="header" :style="setupSurveyVariables">
        <div v-if="pageComponent.properties.exit_survey_header && exitSurvey">
          <p>{{ pageComponent.properties.exit_survey_header | stripHtml }}</p>
        </div>
        <p v-else>{{ survey.role }}</p>
      </div>

      <div class="survey-questions-container" :style="setupSurveyVariables">
        <div class="survey-contents">
          <h2>{{ pageComponent.properties.role_sub_header | stripHtml }}</h2>
          <p v-if="!exitSurvey" class="body-copy">{{ pageComponent.properties.role_intro_blurb | stripHtml }}</p>
          <p v-else class="body-copy">{{ pageComponent.properties.welcome_intro_blurb_exit_survey | stripHtml }}</p>

          <div class="row">
            <div class="col-6">
              <div class="question-container">
                <p>{{ pageComponent.properties.question_one | stripHtml }}</p>
                <div class="rating-option">
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_one${pageComponent.uuid}`" value="Strongly disagree" v-model="survey.question_one.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="disagree">{{ pageComponent.properties.range_text_left | stripHtml }}</span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_one${pageComponent.uuid}`" value="Disagree" v-model="survey.question_one.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_one${pageComponent.uuid}`" value="Neither agree nor disagree" v-model="survey.question_one.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_one${pageComponent.uuid}`" value="Agree" v-model="survey.question_one.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_one${pageComponent.uuid}`" value="Strongly agree" v-model="survey.question_one.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="agree">{{ pageComponent.properties.range_text_right | stripHtml }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="question-container">
                <p>{{ pageComponent.properties.question_two | stripHtml }}</p>
                <div class="rating-option">
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_two${pageComponent.uuid}`" value="Strongly disagree" v-model="survey.question_two.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="disagree">{{ pageComponent.properties.range_text_left | stripHtml  }}</span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_two${pageComponent.uuid}`" value="Disagree" v-model="survey.question_two.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_two${pageComponent.uuid}`" value="Neither agree nor disagree" v-model="survey.question_two.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_two${pageComponent.uuid}`" value="Agree" v-model="survey.question_two.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_two${pageComponent.uuid}`" value="Strongly agree" v-model="survey.question_two.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="agree">{{ pageComponent.properties.range_text_right | stripHtml }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="question-container">
                <p>{{ pageComponent.properties.question_three | stripHtml }}</p>
                <div class="rating-option">
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_three${pageComponent.uuid}`" value="Strongly disagree" v-model="survey.question_three.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="disagree">{{ pageComponent.properties.range_text_left | stripHtml  }}</span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_three${pageComponent.uuid}`" value="Disagree" v-model="survey.question_three.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_three${pageComponent.uuid}`" value="Neither agree nor disagree" v-model="survey.question_three.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_three${pageComponent.uuid}`" value="Agree" v-model="survey.question_three.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_three${pageComponent.uuid}`" value="Strongly agree" v-model="survey.question_three.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="agree">{{ pageComponent.properties.range_text_right | stripHtml }}</span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="question-container">
                <p>{{ pageComponent.properties.question_four | stripHtml }}</p>
                <div class="rating-option">
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_four${pageComponent.uuid}`" value="Strongly disagree" v-model="survey.question_four.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="disagree">{{ pageComponent.properties.range_text_left | stripHtml }}</span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_four${pageComponent.uuid}`" value="Disagree" v-model="survey.question_four.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_four${pageComponent.uuid}`" value="Neither agree nor disagree" v-model="survey.question_four.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_four${pageComponent.uuid}`" value="Agree" v-model="survey.question_four.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                  </label>
                  <label class="rating-circle-container">
                    <input type="radio" :name="`question_four${pageComponent.uuid}`" value="Strongly agree" v-model="survey.question_four.answer" @click.stop="selectRating">
                    <span class="checkmark"></span>
                    <span class="agree">{{ pageComponent.properties.range_text_right | stripHtml }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="role-based-message-container" :style="setupSurveyVariables">
        <div class="contents">
          <!-- Role Based Message: Header-->
          <div v-if="survey.role === 'Customer'">
            <h3 v-html="pageComponent.properties.customer_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Elected Official'">
            <h3 v-html="pageComponent.properties.elected_official_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Business/Community Leader'">
            <h3 v-html="pageComponent.properties.business_community_leader_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Regulator'">
            <h3 v-html="pageComponent.properties.regulator_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Supplier/Partner'">
            <h3 v-html="pageComponent.properties.supplier_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Employee'">
            <h3 v-html="pageComponent.properties.employee_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Student'">
            <h3 v-html="pageComponent.properties.student_title"></h3>
          </div>
          <div v-else-if="survey.role === 'Other'">
            <h3 v-html="pageComponent.properties.other_title"></h3>
          </div>
          <div v-else>
            <h3>{{ pageComponent.properties.skip_role_header }}</h3>
          </div>

          <!-- Role Messages -->
          <div v-if="survey.role === 'Customer'">
            <div class="body-copy" v-html="pageComponent.properties.customer_message"></div>
          </div>
          <div v-else-if="survey.role === 'Elected Official'">
            <div class="body-copy" v-html="pageComponent.properties.elected_official_message"></div>
          </div>
          <div v-else-if="survey.role === 'Business/Community Leader'">
            <div class="body-copy" v-html="pageComponent.properties.business_community_leader_message"></div>
          </div>
          <div v-else-if="survey.role === 'Regulator'">
            <div class="body-copy" v-html="pageComponent.properties.regulator_message"></div>
          </div>
          <div v-else-if="survey.role === 'Supplier/Partner'">
            <div class="body-copy" v-html="pageComponent.properties.supplier_message"></div>
          </div>
          <div v-else-if="survey.role === 'Employee'">
            <div class="body-copy" v-html="pageComponent.properties.employee_message"></div>
          </div>
          <div v-else-if="survey.role === 'Student'">
            <div class="body-copy" v-html="pageComponent.properties.student_message"></div>
          </div>
          <div v-else-if="survey.role === 'Other'">
            <div class="body-copy" v-html="pageComponent.properties.other_message"></div>
          </div>
          <div v-else>
            <div class="body-copy">{{ pageComponent.properties.skip_role_text }}</div>
          </div>

          <div class="survey-btn-group">
            <button v-if="!exitSurvey" class="begin-btn" @click="saveSurvey" :disabled="isDisabled">{{ pageComponent.properties.submit_btn_text | stripHtml }}</button>
            <button v-else class="begin-btn" @click="saveSurvey" :disabled="isDisabled">{{ pageComponent.properties.exit_survey_submit_btn_text | stripHtml }}</button>
            <button @click="skipSurvey" class="skip-btn">{{ pageComponent.properties.skip_survey_text | stripHtml  }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HelperMethods from '../mixins/helper_methods';
import ComponentEventHelper from '../mixins/component_event_helper';
import OrderingHelper from '../mixins/ordering_helper';

export default {
  name: 'KioskSurvey',
  mixins: [HelperMethods, OrderingHelper, ComponentEventHelper],
  props: {
    pageComponent: Object,
    parentComponent: Object,
    kioskProperties: Object,
    sessionUuid: String,
  },
  computed: {
    isDisabled() {
      // disable begin button until all answers are checked
      return !(this.survey.question_one.answer && this.survey.question_two.answer && this.survey.question_three.answer && this.survey.question_four.answer);
    },
    setupSurveyVariables() {
      const titleHeaderWidth = parseInt(this.pageComponent.properties.title_header_role_width, 10);
      const titleHeaderRoleHeight = parseInt(this.pageComponent.properties.title_header_role_height, 10);
      const titleHeaderRoleFontSize = parseInt(this.pageComponent.properties.title_header_role_font_size, 10);
      const titleHeaderColour = this.pageComponent.properties.title_header_colour;
      const titleHeaderTextColour = this.pageComponent.properties.title_header_text_colour;
      const surveyRoleWidth = parseInt(this.pageComponent.properties.survey_role_width, 10);
      const surveyButtonHeight = parseInt(this.pageComponent.properties.survey_button_height, 10);
      const surveyButtonFontSize = parseInt(this.pageComponent.properties.survey_button_font_size, 10);

      const surveyContentsWidth = parseInt(this.pageComponent.properties.survey_contents_width, 10);
      const contentsWidth = parseInt(this.pageComponent.properties.contents_width, 10);
      const roleBasedMessageFontSize = parseInt(this.pageComponent.properties.role_based_message_font_size, 10);
      const agreeDisagreeLabelFontSize = parseInt(this.pageComponent.properties.agree_disagree_label_font_size, 10);
      const skipSurveyFontSize = parseInt(this.pageComponent.properties.skip_survey_font_size, 10);
      const beginButtonWidth = parseInt(this.pageComponent.properties.begin_button_width, 10);
      const beginButtonHeight = parseInt(this.pageComponent.properties.begin_button_height, 10);
      const beginButtonFontSize = parseInt(this.pageComponent.properties.begin_button_font_size, 10);
      const roleBasedMessageHeaderFontSize = parseInt(this.pageComponent.properties.role_based_message_header_font_size, 10);
      const rowHeight = parseInt(this.pageComponent.properties.row_height, 10);

      const surveyAnswersWidth = parseInt(this.pageComponent.properties.width, 10);
      const surveyAnswersHeight = parseInt(this.pageComponent.properties.height, 10);

      const surveyContainerHeight = parseInt(this.pageComponent.properties.survey_container_height, 10);
      const surveyQuestionContainerHeight = parseInt(this.pageComponent.properties.survey_question_container_height, 10);
      const roleBasedMessageContainerHeight = parseInt(this.pageComponent.properties.role_based_message_container_height, 10);
      const introBlurbFontSize = parseInt(this.pageComponent.properties.intro_blurb_font_size, 10);
      const bodyCopyFontSize = parseInt(this.pageComponent.properties.body_copy_font_size, 10);
      const questionColumnWidth = parseInt(this.pageComponent.properties.question_column_width, 10);
      const ratingOptionWidth = parseInt(this.pageComponent.properties.rating_option_width, 10);
      const ratingCircleContainerMarginBot = parseInt(this.pageComponent.properties.rating_circle_container_margin_bot, 10);
      const radioButtonSize = parseInt(this.pageComponent.properties.radio_button_size, 10);
      const agreePositionRight = parseInt(this.pageComponent.properties.agree_position_right, 10);
      const disagreePositionLeft = parseInt(this.pageComponent.properties.disagree_position_left, 10);

      // Variables
      return {
        '--titleHeaderWidth': `${titleHeaderWidth}px`,
        '--titleHeaderRoleHeight': `${titleHeaderRoleHeight}px`,
        '--titleHeaderRoleFontSize': `${titleHeaderRoleFontSize}px`,
        '--titleHeaderColour': `${titleHeaderColour}`,
        '--titleHeaderTextColour': `${titleHeaderTextColour}`,
        '--surveyRoleWidth': `${surveyRoleWidth}px`,
        '--surveyButtonHeight': `${surveyButtonHeight}px`,
        '--surveyButtonFontSize': `${surveyButtonFontSize}px`,
        '--surveyContentsWidth': `${surveyContentsWidth}px`,
        '--contentsWidth': `${contentsWidth}px`,
        '--roleBasedMessageFontSize': `${roleBasedMessageFontSize}px`,
        '--agreeDisagreeLabelFontSize': `${agreeDisagreeLabelFontSize}px`,
        '--skipSurveyFontSize': `${skipSurveyFontSize}px`,
        '--beginButtonWidth': `${beginButtonWidth}px`,
        '--beginButtonHeight': `${beginButtonHeight}px`,
        '--beginButtonFontSize': `${beginButtonFontSize}px`,
        '--roleBasedMessageHeaderFontSize': `${roleBasedMessageHeaderFontSize}px`,
        '--rowHeight': `${rowHeight}px`,
        '--surveyAnswersWidth': `${surveyAnswersWidth}px`,
        '--surveyAnswersHeight': `${surveyAnswersHeight}px`,
        '--surveyContainerHeight': `${surveyContainerHeight}px`,
        '--surveyQuestionContainerHeight': `${surveyQuestionContainerHeight}px`,
        '--roleBasedMessageContainerHeight': `${roleBasedMessageContainerHeight}px`,
        '--introBlurbFontSize': `${introBlurbFontSize}px`,
        '--bodyCopyFontSize': `${bodyCopyFontSize}px`,
        '--questionColumnWidth': `${questionColumnWidth}px`,
        '--ratingOptionWidth': `${ratingOptionWidth}px`,
        '--ratingCircleContainerMarginBot': `${ratingCircleContainerMarginBot}px`,
        '--radioButtonSize': `${radioButtonSize}px`,
        '--agreePositionRight': `${agreePositionRight}px`,
        '--disagreePositionLeft': `${disagreePositionLeft}px`,
      };
    },
  },
  created() {
    // Overwrite default styles
    this.hijackStyles();
  },
  data() {
    return {
      properties: this.pageComponent.properties,
      roles: ['Customer', 'Elected Official', 'Business/Community Leader', 'Regulator', 'Supplier/Partner', 'Employee', 'Student', 'Other'],
      survey: {
        role: '',
        question_one: {
          question: this.pageComponent.properties.question_one,
          answer: null,
        },
        question_two: {
          question: this.pageComponent.properties.question_two,
          answer: null,
        },
        question_three: {
          question: this.pageComponent.properties.question_three,
          answer: null,
        },
        question_four: {
          question: this.pageComponent.properties.question_four,
          answer: null,
        },
      },
      skipTarget: null,
      cardClicked: false,
      exitSurvey: false,
    };
  },
  methods: {
    hijackStyles() {
      // set bg to transparent since we removed the ability to control this in the survey's properties
      this.pageComponent.properties.fill = 'transparent';
    },
    determineRoleContent(index) {
      if (this.properties.button_sound) {
        const audioSrc = this.properties.button_sound;
        if (audioSrc) {
          const audio = new Audio(audioSrc);
          audio.play();
        }
      }
      // this.survey.role = this.roles[index];
      // test
      this.pageComponent.properties.role = this.roles[index];
      this.survey.role = this.pageComponent.properties.role;
      //
      const surveyContainer = this.$refs[`survey-${this.pageComponent.uuid}`];
      const roleSelection = this.$refs[`role-selection-${this.pageComponent.uuid}`];
      if (surveyContainer && roleSelection) {
        // Set the role for the session
        // this.kioskProperties.role = this.survey.role;
        surveyContainer.classList.add('active');
        roleSelection.classList.add('hidden');
      }
    },
    selectRating() {
      if (this.properties.button_sound) {
        const audioSrc = this.properties.button_sound;
        if (audioSrc) {
          const audio = new Audio(audioSrc);
          audio.play();
        }
      }
      return false; // keep playing
    },
    saveSurvey() {
      if (this.survey) {
        // this.resetSurveyData();
        // call skipSurvey to show original target and close current survey
        this.reportAnalytics();
        this.skipSurvey('true');
        if (this.properties.begin_sound) {
          const audioSrc = this.properties.begin_sound;
          if (audioSrc) {
            const audio = new Audio(audioSrc);
            audio.play();
          }
        }
      }
    },
    reportAnalytics(type = 'save_survey') {
      const userEvent = {};
      userEvent.target_uuid = this.pageComponent.uuid;
      userEvent.type = type; // use this on button click and test with register action, maybe even add in this method
      userEvent.data = this.survey;
      userEvent.data.userAction = true;
      this.fireEventRecorder(userEvent, true);
    },
    resetSession() {
      const clearEvent = {};
      clearEvent.target_uuid = this.sessionUuid;
      clearEvent.type = 'clear_session';
      clearEvent.sessionUuid = this.sessionUuid;
      this.fireEventRecorder(clearEvent, true);
    },
    skipSurvey(cancelAudio) {
      // check kiosk properties and see what the most current last target is (for the new even)
      const newEvent = {};
      if (this.skipTarget) {
        newEvent.target_uuid = this.skipTarget;
        newEvent.type = 'show'; // use this on button click and test with register action, maybe even add in this method
      }
      const hideEvent = {};
      hideEvent.target_uuid = this.pageComponent.uuid;
      hideEvent.type = 'hide';


      // this.exitSurvey = true;
      // If exit survey, reset it back to the original survey type, show roles again
      // if (this.exitSurvey) {
      // this.exitSurvey = false;
      // this.pageComponent.properties.role = '';
      const surveyContainer = this.$refs[`survey-${this.pageComponent.uuid}`];
      const roleSelection = this.$refs[`role-selection-${this.pageComponent.uuid}`];

      if (surveyContainer && roleSelection) {
        // Set the role selection back after the exit survey has been completed
        surveyContainer.classList.remove('hidden');
        surveyContainer.classList.add('active');
        roleSelection.classList.add('hidden');
      }

      if (!this.pageComponent.properties.role) {
        this.survey.role = 'skipped';
        // this.pageComponent.properties.role = 'skipped';
      }

      // this.resetSurveyData(); // reset data
      this.resetQuestionAnswers();

      // emit for new
      this.$eventHub.$emit(this.pageComponent.uuid, newEvent);
      this.$eventHub.$emit(this.pageComponent.uuid, hideEvent);

      if (this.properties.button_sound && cancelAudio !== 'true') {
        const audioSrc = this.properties.button_sound;
        if (audioSrc) {
          const audio = new Audio(audioSrc);
          audio.play();
        }
      }

      if (!this.exitSurvey) {
        this.exitSurvey = true;
      } else {
        // clear the session if it's the exit survey
        this.resetSession();

        this.resetSurveyData(); // reset data
        this.cardClicked = false;
        this.exitSurvey = false;
        if (surveyContainer && roleSelection) {
          // Set the role selection back after the exit survey has been completed
          surveyContainer.classList.add('hidden');
          surveyContainer.classList.remove('active');
          roleSelection.classList.remove('hidden');
          roleSelection.classList.add('active');
        }
      }
    },
    resetSurveyData() {
      this.survey = {
        role: '',
        question_one: {
          question: this.pageComponent.properties.question_one,
          answer: null,
        },
        question_two: {
          question: this.pageComponent.properties.question_two,
          answer: null,
        },
        question_three: {
          question: this.pageComponent.properties.question_three,
          answer: null,
        },
        question_four: {
          question: this.pageComponent.properties.question_four,
          answer: null,
        },
      };
    },
    resetQuestionAnswers() {
      const currentRole = this.survey.role;
      this.survey = {
        role: currentRole,
        question_one: {
          question: this.pageComponent.properties.question_one,
          answer: null,
        },
        question_two: {
          question: this.pageComponent.properties.question_two,
          answer: null,
        },
        question_three: {
          question: this.pageComponent.properties.question_three,
          answer: null,
        },
        question_four: {
          question: this.pageComponent.properties.question_four,
          answer: null,
        },
      };
    },
    resetCallback() {
      // reset styles on survey + target elements
      // this.kioskProperties.role = '';
      this.properties = Object.assign({}, this.properties, {
        fill: 'transparent',
        role: '',
      });
      this.resetSurveyData();
      this.resetQuestionAnswers();
      this.cardClicked = false;
      this.skipTarget = null;
      this.exitSurvey = false;

      const surveyContainer = this.$refs[`survey-${this.pageComponent.uuid}`];
      const roleSelection = this.$refs[`role-selection-${this.pageComponent.uuid}`];

      if (surveyContainer && roleSelection) {
        // Set the role selection back after the exit survey has been completed
        surveyContainer.classList.add('hidden');
        surveyContainer.classList.remove('active');
        roleSelection.classList.remove('hidden');
        roleSelection.classList.add('active');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  /*  Variables */
  $titleHeaderWidth: var(--titleHeaderWidth);
  $titleHeaderRoleHeight: var(--titleHeaderRoleHeight);
  $titleHeaderRoleFontSize: var(--titleHeaderRoleFontSize);
  $titleHeaderColour: var(--titleHeaderColour);
  $titleHeaderTextColour: var(--titleHeaderTextColour);
  $surveyRoleWidth: var(--surveyRoleWidth);
  $surveyButtonHeight: var(--surveyButtonHeight);
  $surveyButtonFontSize: var(--surveyButtonFontSize);

  $surveyContentsWidth: var(--surveyContentsWidth);
  $contentsWidth: var(--contentsWidth);
  $roleBasedMessageFontSize: var(--roleBasedMessageFontSize);
  $agreeDisagreeLabelFontSize: var(--agreeDisagreeLabelFontSize);
  $skipSurveyFontSize: var(--skipSurveyFontSize);
  $beginButtonWidth: var(--beginButtonWidth);
  $beginButtonHeight: var(--beginButtonHeight);
  $beginButtonFontSize: var(--beginButtonFontSize);
  $roleBasedMessageHeaderFontSize: var(--roleBasedMessageHeaderFontSize);
  $rowHeight: var(--rowHeight);
  $surveyAnswersWidth: var(--surveyAnswersWidth);
  $surveyAnswersHeight: var(--surveyAnswersHeight);
  $surveyContainerHeight: var(--surveyContainerHeight);
  $surveyQuestionContainerHeight: var(--surveyQuestionContainerHeight);
  $roleBasedMessageContainerHeight: var(--roleBasedMessageContainerHeight);
  $introBlurbFontSize: var(--introBlurbFontSize);
  $bodyCopyFontSize: var(--bodyCopyFontSize);
  $questionColumnWidth: var(--questionColumnWidth);
  $ratingOptionWidth: var(--ratingOptionWidth);
  $ratingCircleContainerMarginBot: var(--ratingCircleContainerMarginBot);
  $radioButtonSize: var(--radioButtonSize);
  $agreePositionRight: var(--agreePositionRight);
  $disagreePositionLeft: var(--disagreePositionLeft);

  // Match size of a 'well'
  .survey {
    height: $surveyAnswersHeight;
    width: $surveyAnswersWidth;
    background: linear-gradient(-180deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.5) 100%);
  }

  .role-selection-container {
    .header {
      background: $titleHeaderColour;
      height: $titleHeaderRoleHeight;
      display: flex;
      align-items: center;
      justify-content: center;
      width: $titleHeaderWidth;
      p {
        color: $titleHeaderTextColour;
        font-size: $titleHeaderRoleFontSize;
        font-family: 'Equip', sans-serif;
        margin-top: 15px;
        margin-bottom: 0;
      }
    }

    &.hidden {
      visibility: hidden;
    }
  }

  .role-section-selection {
    width: $surveyRoleWidth;
    text-align: left;
    margin: 60px auto 0;
    font-size: $introBlurbFontSize;
  }

  .roles-list {
    width: 100%;
    list-style-type: none;
    padding: 0;
    margin: 30px 0 60px 0;
  }

/*   Survey  */
  .survey-container {
    @extend .survey;
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s linear 0.33s, opacity 0.33s linear;
    position: absolute;
    top: 0;
    height: $surveyContainerHeight;
    &.active {
      visibility: visible;
      opacity: 1;

      transition-delay: 0s;
    }

    .header {
      background: $titleHeaderColour;
      width: 100%;
      height: $titleHeaderRoleHeight;
      display: flex;
      align-items: center;
      justify-content: center;
      p {
        /*color: rgb(0, 51, 102);*/
        color: $titleHeaderTextColour;
        font-size: $titleHeaderRoleFontSize;
        font-family: 'Equip', sans-serif;
        margin-top: 15px;
        margin-bottom: 0;
      }
    }
    .survey-questions-container {
      background-color: #dee7f2;
      width: 100%;
      padding: 34px 0 0;
      height: $surveyQuestionContainerHeight;
    }

    .survey-contents {
      width: $surveyContentsWidth;
      text-align: left;
      margin: 0 auto;

      h2 {
        margin-bottom: 20px;
      }

      .body-copy {
        font-size: $bodyCopyFontSize;
      }

      .question-container {
        p {
          font-size: $bodyCopyFontSize;
        }
      }
    }
  }

  /* The rating-circle-container */
  .rating-circle-container {
    display: inline-block;
    position: relative;
    padding-left: 35px;
    margin-bottom: $ratingCircleContainerMarginBot;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default radio button */
  .rating-circle-container input {
    position: absolute;
    left: 0;
    margin: 0;
    padding: 0;
    width: $radioButtonSize;
    height: $radioButtonSize;
    opacity: 0;
    cursor: pointer;
  }

  /* Create a custom radio button */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: $radioButtonSize;
    width: $radioButtonSize;
    background-color: #FFF;
    border-radius: 50%;
  }

  /* On mouse-over, add a grey background color */
  .rating-circle-container:hover input ~ .checkmark {
    background: rgba(255, 255, 255, 0.3);
  }

  /* When the radio button is checked, add a blue background */
  .rating-circle-container input:checked ~ .checkmark {
    background-color: #266AC1;
  }

  /* Show the indicator (dot/circle) when checked */
  .rating-circle-container input:checked ~ .checkmark:after {
    display: block;
  }

  .rating-circle-container span {
    pointer-events: none;
  }

  /* Style the indicator (dot/circle) */
  .rating-circle-container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #266AC1;
  }

  .question-container {
    width: $questionColumnWidth;
  }

  .rating-option {
    display: flex;
    justify-content: space-between;
    width: $ratingOptionWidth;
    height: 110px;
  }


  /* Agree / Disagree Text */
  .disagree {
    position: absolute;
    bottom: 0;
    left: $disagreePositionLeft;
    font-size: $agreeDisagreeLabelFontSize;
    white-space: nowrap;
  }

  .agree {
    position: absolute;
    bottom: 0;
    right: $agreePositionRight;
    font-size: $agreeDisagreeLabelFontSize;
    white-space: nowrap;
  }

  .row {
    height: $rowHeight;
  }

/*  role-based-message-container */
  .role-based-message-container {
    width: 100%;
    padding: 34px 0 0;
    height: $roleBasedMessageContainerHeight;
    .contents {
      width: $contentsWidth;
      text-align: left;
      margin: 0 auto;
      font-size: $roleBasedMessageFontSize;
      h3 {
        font-size: $roleBasedMessageHeaderFontSize;
        margin: 0 0 15px 0;
      }

      .body-copy {
        font-size: $bodyCopyFontSize;
      }
    }
  }

  /* Buttons */
  .survey-btn-group {
    display: block;
    margin: 10px auto 0;
    padding: 10px 0 0 0;
  }

  .role-button {
    width: 100%;
    button {
      width: 100%;
      height: $surveyButtonHeight;
      margin-bottom: 25px;
      background-color: #266ac1;
      border-color: #266ac1;
      color: #fff;
      font-size: $surveyButtonFontSize;

      &:focus {
        background-color: #266ac1;
        border-color: #266ac1;
        outline: 0;
      }
    }
  }

  .skip-btn {
    text-decoration: underline;
    display: block;
    margin: 0 auto;
    color: #266ac1;
    font-size: $skipSurveyFontSize;
    height: 50px;
    text-align: center;
    background: transparent;
    border: none;
    outline: 0;
    &:focus {
      outline: 0;
    }
  }

  .begin-btn {
    height: $beginButtonHeight;
    font-size: $beginButtonFontSize;
    color: white;
    text-align: center;
    background: #266ac1;
    border-radius: 10px;
    width: $beginButtonWidth;
    display: block;
    margin: 0 auto;
    &[disabled] {
      background: #f2f2f2;
    }
  }
</style>
